// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1lk3y","empty":"ModalGraph_empty__3x2Jv"};